import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import './FAQ.css';

export default function FAQ({ items }) {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div className="faq-shell">
      {items.map((item, index) => (
        <button
          key={item.question}
          type="button"
          className={`faq-item ${openIndex === index ? 'open' : ''}`}
          onClick={() => setOpenIndex(openIndex === index ? null : index)}
          aria-expanded={openIndex === index}
        >
          <div className="faq-question">
            <span>{item.question}</span>
            <ChevronDown size={20} />
          </div>
          <div className="faq-answer">
            <p>{item.answer}</p>
          </div>
        </button>
      ))}
    </div>
  );
}
